import type { ClientSendingProblem, EmailAccountUnusableReason } from "../../../api/emailAccountsTypes";

export const unusableReasonLabels: Record<EmailAccountUnusableReason, string> = {
  AccountDisabled: "Address is disabled",
  DomainNotHeld: "Domain is not held by this organization",
  DomainMissingFromMailgun: "Domain is no longer in Mailgun",
  DomainNotActive: "Domain is not active",
};

export const sendingProblemLabels: Record<ClientSendingProblem, string> = {
  NoUsableAccount: "no usable address",
  NoDefaultChosen: "several addresses and no default chosen",
  DefaultNotAssigned: "the default address is not assigned to it",
  DefaultNotUsable: "the default address cannot send",
};
